function gcd(a, b) {
  /* return greatest common divisor */
  return b == 0 ? a : gcd(b, a % b);
}

export function getAspectRatio(w, h) {
  const r = gcd(w, h);

  return [w / r, h / r];
}

export const loadImageAsDataUrl = async (file, options = {}) => {
  options.canvas = true;

  const c = await import('blueimp-load-image');
  const loadImage = c.default;
  return await new Promise((resolve, reject) => {
    loadImage.parseMetaData(file, data => {
      if (data.exif) {
        options.orientation = data.exif.get('Orientation');
      }

      loadImage(
        file,
        canvas => {
          if (canvas.width === 0 || canvas.height === 0) {
            canvas.type = 'error';
          }

          if (canvas.type === 'error') {
            const error = new Error(`Could not load a file '${file.name}'`);
            error.file = file;
            reject(error);
          } else {
            resolve(canvas.toDataURL());
          }
        },
        options
      );
    });
  });
};
